import React, { useState } from "react";

import axios from "axios";

import "./FaceMatchForm.css";

import Sidebar from "../Sidebar";

import TopNavbar from "../../top-navbar/TopNav";
 
const FaceMatchForm = () => {

  const [aadhaarPhoto, setAadhaarPhoto] = useState(null);

  const [selfiePhoto, setSelfiePhoto] = useState(null);

  const [aadhaarPreview, setAadhaarPreview] = useState(null);

  const [selfiePreview, setSelfiePreview] = useState(null);

  const [aadhaarUploaded, setAadhaarUploaded] = useState(false);

  const [selfieUploaded, setSelfieUploaded] = useState(false);

  const [verificationResult, setVerificationResult] = useState(null);

  const [loading, setLoading] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [showFailureModal, setShowFailureModal] = useState(false);

  const [manualReview, setManualReview] = useState(false);

  const [error, setError] = useState(null);
 
  const API_URL = "https://qa.trueface.co.in/api/employee";

  const token = localStorage.getItem("bgc_token");
 
  const handleAadhaarChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;
 
    if (!file.type.startsWith("image/")) {

      alert("Please upload a valid image file.");

      return;

    }
 
    setAadhaarPhoto(file);

    setAadhaarPreview(URL.createObjectURL(file));

    setAadhaarUploaded(true);

  };
 
  const handleSelfieChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;
 
    if (!file.type.startsWith("image/")) {

      alert("Please upload a valid image file.");

      return;

    }
 
    setSelfiePhoto(file);

    setSelfiePreview(URL.createObjectURL(file));

    setSelfieUploaded(true);

  };
 
  const handleStartVerification = async () => {

    if (!aadhaarPhoto || !selfiePhoto) {

      alert("Please upload both Aadhaar and Selfie photos!");

      return;

    }
 
    if (!token) {

      alert("❌ You are not authorized. Please log in again.");

      return;

    }
 
    setLoading(true);

    setError(null);

    setShowSuccessModal(false);

    setShowFailureModal(false);

    setManualReview(false);

    setVerificationResult(null);
 
    try {

      const formData = new FormData();

      formData.append("selfie", selfiePhoto);

      formData.append("idPhoto", aadhaarPhoto);
 
      const response = await axios.post(`${API_URL}/match/upload`, formData, {

        headers: {

          "Content-Type": "multipart/form-data",

          Authorization: `Bearer ${token}`,

        },

      });
 
      const res = response.data;

      setVerificationResult(res);
 
      const confidence = res.confidence < 1 ? res.confidence * 100 : res.confidence;
 
      // NEW LOGIC

      if (confidence > 40) {

        setShowSuccessModal(true);

      } else if (confidence >= 10 && confidence <= 40) {

        setManualReview(true);

      } else {

        setShowFailureModal(true);

      }

    } catch (err) {

      console.error("❌ Verification error:", err);

      setError("Error during verification. Please try again.");

    } finally {

      setLoading(false);

    }

  };
 
  const handleReset = () => {

    setAadhaarPhoto(null);

    setSelfiePhoto(null);

    setAadhaarPreview(null);

    setSelfiePreview(null);

    setAadhaarUploaded(false);

    setSelfieUploaded(false);

    setVerificationResult(null);

    setShowSuccessModal(false);

    setShowFailureModal(false);

    setManualReview(false);

    setError(null);

    setLoading(false);
 
    document.getElementById("aadhaarInput").value = "";

    document.getElementById("selfieInput").value = "";

  };
 
  if (!token) {

    return (
<div className="emp-dashboard-container">
<Sidebar />
<div className="emp-main-panel">
<TopNavbar />
<div className="unauth-container">
<h3>❌ Authentication Error</h3>
<p>Please log in to continue.</p>
</div>
</div>
</div>

    );

  }
 
  return (
<div className="emp-dashboard-container">
<Sidebar />
<div className="emp-main-panel">
<TopNavbar />
 
        <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-2xl p-6 mt-10 border border-gray-200 animate-fadeIn">
<h2 className="text-2xl font-bold text-center mb-6 text-gray-800">

            Face Match Verification
</h2>
 
          <p className="guidelines-text">

            Please upload a clear photo of your Aadhaar card (front side) and your recent selfie.
</p>
 
          {/* Upload Sections */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
<div className="flex flex-col items-center border rounded-lg p-4 shadow-sm hover:shadow-md transition">
<h3 className="font-semibold mb-2">Upload Aadhaar Card</h3>
<input

                id="aadhaarInput"

                type="file"

                accept="image/*"

                onChange={handleAadhaarChange}

                className="mb-3"

              />

              {aadhaarPreview && (
<img src={aadhaarPreview} alt="Aadhaar Preview" className="preview-image" />

              )}

              {aadhaarUploaded && <p className="text-green-600 text-sm mt-2">Aadhaar Uploaded ✅</p>}
</div>
 
            <div className="flex flex-col items-center border rounded-lg p-4 shadow-sm hover:shadow-md transition">
<h3 className="font-semibold mb-2">Upload Selfie</h3>
<input

                id="selfieInput"

                type="file"

                accept="image/*"

                onChange={handleSelfieChange}

                className="mb-3"

              />

              {selfiePreview && (
<img src={selfiePreview} alt="Selfie Preview" className="preview-image" />

              )}

              {selfieUploaded && <p className="text-green-600 text-sm mt-2">Selfie Uploaded ✅</p>}
</div>
</div>
 
          {/* Buttons */}
<div className="flex justify-center gap-4 mt-8">
<button

              onClick={handleStartVerification}

              disabled={loading}

              className={`action-btn primary facematch-btn ${loading ? "loading" : ""}`}
>

              {loading ? "Verifying..." : "Start Verification"}
</button>
 
            <button onClick={handleReset} className="action-btn secondary facematch-btn">

              Reset
</button>
</div>
 
          {/* SUCCESS */}

          {showSuccessModal && (
<div className="alert success">
<h4>✅ Face Match Successful!</h4>
<p>Verification passed with good confidence.</p>
</div>

          )}
 
          {/* FAILURE */}

          {showFailureModal && (
<div className="alert failure">
<h4>❌ Face Match Failed!</h4>
<p>Please try again with a clearer image.</p>
</div>

          )}
 
          {/* MANUAL REVIEW */}

          {manualReview && (
<div className="alert manual">
<h4>⚠️ Manual Review Required</h4>
<p>Your identity verification will be checked manually.</p>
</div>

          )}
 
          {/* ERROR */}

          {error && (
<div className="text-center mt-6 text-red-600 text-sm">

              ❌ {error}
</div>

          )}
</div>
</div>
</div>

  );

};
 
export default FaceMatchForm;

 